import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
export interface GalleryImage {
  id: number;
  src: string;
  title: string;
  category: string;
  width?: number;
  height?: number;
}
interface GalleryGridProps {
  images: GalleryImage[];
  onImageClick: (index: number) => void;
}
export function GalleryGrid({
  images,
  onImageClick
}: GalleryGridProps) {
  return <div className="columns-1 md:columns-2 lg:columns-3 xl:columns-4 gap-6 space-y-6" data-id="element-326">
      {images.map((image, index) => <motion.div key={image.id} layout initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      delay: index * 0.05
    }} className="break-inside-avoid" data-id="element-327">
          <div className="group relative overflow-hidden bg-[#11161A] border border-white/5 cursor-pointer" onClick={() => onImageClick(index)} data-id="element-328">
            <img src={image.src} alt={image.title} className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" data-id="element-329" />

            {/* Overlay */}
            <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-4 text-center" data-id="element-330">
              <span className="text-[#DDA247] text-xs font-bold uppercase tracking-widest mb-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-75" data-id="element-331">
                {image.category}
              </span>
              <h3 className="text-white font-bold text-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-100" data-id="element-332">
                {image.title}
              </h3>
              <div className="mt-4 w-10 h-10 rounded-full border border-white/30 flex items-center justify-center transform scale-0 group-hover:scale-100 transition-transform duration-300 delay-150" data-id="element-333">
                <Plus className="w-5 h-5 text-white" data-id="element-334" />
              </div>
            </div>

            {/* Border Effect */}
            <div className="absolute inset-0 border-2 border-[#DDA247] opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-335" />
          </div>
        </motion.div>)}
    </div>;
}